import template from "./template"


export default {
	modules: {
		template: template,
	},
	strict: true,
	namespaced: true,
}